import React, { useMemo } from "react";

import "./index.scss";

const CustomTooltip = ({ active, payload, label, refAreaLeft, refAreaRight }: any) => {
  const data = useMemo(() => {
    if (!(active && payload && payload.length)) return null;
    return payload.find(Boolean).payload;
  }, [payload, active]);

  const timeRangeLabel = useMemo(() => {
    if (!refAreaLeft || !refAreaRight) return "";
    const [left, right] = [refAreaLeft.time, refAreaRight.time].sort();
    return `${left} - ${right}`;
  }, [refAreaLeft, refAreaRight]);

  const timeDiffLabel = useMemo(() => {
    if (!refAreaLeft || !refAreaRight) return "";
    const [left, right] = [refAreaLeft.seconds, refAreaRight.seconds].sort();
    return (right - left).toFixed(4);
  }, [refAreaLeft, refAreaRight]);

  const labelTimeText = useMemo(() => {
    return label;
  }, [label]);

  const labelValueText = useMemo(() => {
    return payload?.find(Boolean)?.payload?.value;
  }, [payload]);

  return data ? (
    <div className="custom-tooltip">
      <p className="label-text">Time: {labelTimeText}</p>
      <p className="label-text">Value: {labelValueText}</p>
      <div className="custom-content">
        {refAreaLeft && refAreaRight ? <div className="selected-items">Time Range: {timeRangeLabel}</div> : null}
      </div>
      <div className="custom-content">
        {refAreaLeft && refAreaRight ? <div className="selected-items">Time Difference: {timeDiffLabel}s</div> : null}
      </div>
    </div>
  ) : null;
};

export default CustomTooltip;
